export default __webpack_public_path__ + "static/media/rainbow hat.7663aaeb.png";